import React, {  useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contextos/AuthProvider'
import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import { EncApi } from '../Comunes/Listas';
const GeneralCatalogo = (props) => {
    const { PerfilUsuario, Token } = useAuth();
    const navigate = useNavigate();

    const Salir = () => {
        navigate("/");
    }
    const Avance = (Codigo) => {
        props.CambiaCia(Codigo)
        navigate("/Productos/FichaCatalogo");
    }
    const handleOnSubmit = (e) => {
        console.log("in submit");
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };


    const [Gestor, setGestor] = React.useState({
       
        Criterio: ''
    });
    const CambiaDatosGestor = (e) => {

        const { className, name, value, type } = e.target;
       
        if (className === 'ck') {

            e.target.checked = false;
        }
        setGestor({ ...Gestor, [name]: (type === 'number') ? parseInt(value) : value });
    }
    const [LosProductos, setLosProductos] = React.useState([]);
    const cargandoArticulos = async () => {
        //console.log(await Token);

        console.log(Token);
        await fetch('https://smartfecr.com:2020/SmartContrackBack/api/Inventario/BusquedaCatalogo?IdCia=' + PerfilUsuario.IdCia +'&Criterio=' + Gestor.Criterio, EncApi(Token)
        ).then(response => response.json())
            .then(json => {
                //  console.log(json)
                setLosProductos(json)
                let Limpia = {
                    Criterio: ''
                }
                setGestor(Limpia)
            })
    }

    useEffect(() => {
        if (PerfilUsuario) {
            setGestor({
                ...Gestor,
                "Criterio": ''
            });
        }

        // eslint-disable-next-line
    }, [])

    if (PerfilUsuario) {
        return <div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
            <div className='formadoShadow'>

                <div className='tituloPantalla'>
                <p style={{ display: 'inline-block' }}> Administración Productos y Servicios</p>
                <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                </div>

                <div className="row">
                
                <div className="col-50">
                    <span className="col-form-span" >Referencia Búsqueda </span>
                    <input type="text" id="Criterio" autoComplete='off' name="Criterio" 
                    placeholder="Código o Descripción del Producto" 
                    value={Gestor.Criterio} onChange={CambiaDatosGestor} onKeyDown={(e) => {
                        console.log(e.key);
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            cargandoArticulos();
                        }}}></input>
                 
                
                </div>
                   
                <div className="col-25">
                    <div className='row'>
                    <div className='col-50'>
                        <button id="Buscar" onClick={() => cargandoArticulos()} name="Buscar">Buscar</button>
                    </div>
                    <div className='col-50'>
                        <button id="Buscar" onClick={() => Avance('')} name="Buscar">Nuevo</button>
                    </div>
                    </div>

                </div>
                <div className="col-25"></div>
                </div>

                <div className="info" style={{ overflowX: 'auto' }}>
                <table id="tablaArticulos" name="tablaArticulos" className="table-striped table table-sm'">
                    <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}></th>
                        <th style={{ textAlign: 'center' }}>Codigo</th>
                        <th style={{ textAlign: 'center' }}>Descripción</th>
                    </tr>
                    </thead>
                    <tbody>
                    {LosProductos.map((post, index) => {
                        return <tr key={index}>
                        {/*   <td> <input type='checkbox' disabled={post.Estado !== 'Sin Cargar a SAP'} onChange={() => ClicCheckTabla(post.ConsecutivoProveedor, post.CedulaPR)} ></input> </td> */}
                        <td><button onClick={() => Avance(post.DE_CODIGO_ART)} >Modificar</button></td>
                        <td>{post.DE_CODIGO_ART}</td>
                        <td>{post.DE_NOMBRE_ART}</td>
                        </tr>
                    })}
                    </tbody>
                </table>



                </div>

            </div>


            </div>
        </div>
    }
    else {
        return <p>Cargando Proceso Cliente...</p>
    }

}
export default GeneralCatalogo;